import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import { z } from 'zod';
import { PERMISSION_TACHO_CORRECTION } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Form from '../../components/Corrections/Form';
import { URL_CORRECTIONS } from '../../router/constants';

export const Route = createFileRoute('/_authenticated/corrections/edit/$id')({
  validateSearch: z.object({
    customerId: z.coerce.number().optional(),
    locked: z.string().optional(),
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_TACHO_CORRECTION, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.corrections',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditCorrectionRoute,
});

function EditCorrectionRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = React.useCallback(() => {
    navigate({ to: URL_CORRECTIONS });
  }, [navigate]);

  return (
    <Form
      id={Number(id)}
      customerId={search.customerId ?? null}
      handleClose={handleClose}
      locked={search.locked ?? ''}
    />
  );
}
